import React from 'react'
import { fmtCount, fmtPct, funnelSteps } from './model'

// Horizontal bars, each as wide as its share of the first step. The rate
// beside a step is against the step before it ("Sold · 40% of accepted").
export default function ChannelFunnel({ steps, color, label }) {
  const rows = funnelSteps(steps)
  return (
    <ol aria-label={label} style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
      {rows.map((step, i) => (
        <li key={step.label} style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 12 }}>
            <span style={{ color: 'var(--text-secondary)', fontWeight: 600 }}>
              {step.label}
              {step.rate != null && (
                <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}> · {fmtPct(step.rate)} of {rows[i - 1].label.toLowerCase()}</span>
              )}
            </span>
            <span className="pw-num" style={{ color: 'var(--text-primary)', fontWeight: 700 }}>{fmtCount(step.value)}</span>
          </div>
          <div aria-hidden="true" style={{ height: 8, borderRadius: 999, background: 'var(--bg-raised)', overflow: 'hidden' }}>
            <div style={{
              height: '100%', width: `${step.width}%`, borderRadius: 999,
              background: color, opacity: 1 - i * 0.22,
            }} />
          </div>
        </li>
      ))}
    </ol>
  )
}
